import React from 'react';
import PropTypes from 'prop-types';

import Icon from '@assets/theme/icons/icons-16-px-star-filled.svg';

export default function RatingIcon({ color, width = 8, height = 8 }) {
  return (
    <Icon
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 16 16"
      style={{ margin: '4px 2px 4px 0' }}
    />
  );
}

RatingIcon.propTypes = {
  color: PropTypes.string.isRequired,
  height: PropTypes.number,
  width: PropTypes.number,
};
